/**
 * Central API configuration
 * Handles backend URL with fallback to relative paths for production
 */

// In browser (except localhost) => always use same-origin "/api"
// Only on localhost: allow env vars with normalization

const normalizeApiBase = (raw) => {
  if (!raw) return '/api';
  const trimmed = String(raw).trim();
  if (!trimmed) return '/api';
  if (trimmed.startsWith('/')) return trimmed.replace(/\/$/, '');
  const clean = trimmed.replace(/\/$/, '');
  return clean.endsWith('/api') ? clean : `${clean}/api`;
};

const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';
const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(hostname);

const explicitBase =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  '';

const API = (isBrowser && !isLocalHost) ? '/api' : normalizeApiBase(explicitBase);

// Export für direkten Zugriff auf BACKEND_URL (z.B. für Citation URLs)
export const getBackendUrl = () => {
  if (isBrowser) {
    return window.location.origin;
  }
  // Otherwise (SSR/tooling) => return env base without trailing slash and without /api suffix
  const base = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_BASE_URL || "https://api.stadtki.net";
  return String(base).replace(/\/$/, '').replace(/\/api$/, '');
};

// Export API base path
export default API;

// Debug logging (nur in Development)
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'server',
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    API: API
  });
}

